import { render } from "./MusicalLanguage.vue?vue&type=template&id=bc29f086"
import script from "./MusicalLanguage.vue?vue&type=script&lang=js"
export * from "./MusicalLanguage.vue?vue&type=script&lang=js"

import "./MusicalLanguage.vue?vue&type=style&index=0&id=bc29f086&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__